<template>
  <div class="commonPriceBar">
    <div class="pageBack">
      <tk-link @click="$router.go(-1)">
        <tk-svg-icon class="icoBack" icon="prev" />
        前へ
      </tk-link>
    </div>

    <dl class="commonPriceBarInner">
      <dt v-if="description"><span>{{ description }}</span></dt>
      <dt v-else>合計<br class="sp" /><span>"（宿＋航空券）"</span></dt>
      <dd>
        <p v-if="unitPrice">
          <span class="priceMemo">1名</span>
          <span class="fontNo">{{ unitPrice }}</span
          >円
        </p>
        <p class="total" style="color: #f9423a;">
          <span class="priceMemo">{{ personCount }}名合計</span>
          <span class="fontNo fontNoMini">
            {{ paymentAmount }}</span
          >円
        </p>
      </dd>
    </dl>
  </div>
</template>

<script>
import { TkLink, TkSvgIcon } from '@ota-frontend/ui'

export default {
  name: 'TkHotelFixbar',
  components: {
    TkLink,
    TkSvgIcon,
  },
  props: {
    paymentAmount: {
      type: String,
      default: "",
    },
    unitPrice: {
      type: String,
      default: "",
    },
    personCount: {
      type: Number,
      default: 0,
    },
    description: {
      type: String,
      default: "",
    },
  }
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/color.scss';
@import '@ota-frontend/ui/src/scss/mixin.scss';
@import '~@ota-frontend/shared-assets/css/hotel_detail/hotel_fixbar.scss';
</style>
